import { Controller } from "@hotwired/stimulus"

// Drives the mobile nav overlay (#main_menu). Replaces the generic reveal toggle
// so the panel slides in from the right instead of snapping into view.
//
// `hidden` stays the source of truth for open/closed (scroll_lock watches it to
// lock the body, which also clips the off-screen panel during the slide). On top
// of that we toggle an `is-open` class one frame later that the CSS animates:
// reveal off-screen, force a reflow so the start frame paints, then slide in. On
// close we slide back out first and only re-add `hidden` once the panel is off
// screen, so the exit isn't cut off by display:none.
export default class extends Controller {
  static targets = ["panel"]

  toggle() {
    if (this.panelTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    if (this.closeTimer) { clearTimeout(this.closeTimer); this.closeTimer = null }
    this.panelTarget.classList.remove("hidden")
    // Skip the reflow under reduced motion so there's no one-frame flash of the
    // off-screen start state before it snaps into place.
    if (!this.reducedMotion) void this.panelTarget.offsetWidth
    this.panelTarget.classList.add("is-open")
  }

  close() {
    this.panelTarget.classList.remove("is-open")
    clearTimeout(this.closeTimer)
    if (this.reducedMotion) {
      this.panelTarget.classList.add("hidden")
      return
    }
    // Restore display:none once the slide-out finishes (matches the 150ms CSS
    // transition) so scroll_lock unlocks the body and the parked panel can't add
    // horizontal overflow.
    this.closeTimer = setTimeout(() => {
      this.panelTarget.classList.add("hidden")
      this.closeTimer = null
    }, 150)
  }

  get reducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
